import { Pipe, PipeTransform, inject } from '@angular/core';
import { ProductGridEntity } from '@shared/domain/products/product-grid.entity';
import { isNumber } from 'lodash';
import { ENVIRONMENT, SharedEnv } from 'shared-ui/di/environment';

@Pipe({
  name: 'productImageUrl',
  standalone: false,
})
export class ProductImageUrlPipe implements PipeTransform {
  private env = inject<SharedEnv>(ENVIRONMENT);

  transform(product: ProductGridEntity, index?: number): string {
    const image = isNumber(index) ? product.images[index] : product.defaultImage;
    return `${this.env.imagesUrl}/products/${product._id}/${image}`;
  }
}
